import { MenuEntry } from '@europrocurement/flexy-components';
import { dossiersBasePath } from '@europrocurement/l2d-modules';

const menuEntries: MenuEntry[] = [
    {
        title: 'Accueil',
        icon: 'house',
        href: '/accueil',
    },
    {
        title: 'Mes dossiers',
        icon: 'folders',
        href: `/${dossiersBasePath}`,
    },
    {
        title: 'Mes factures',
        icon: 'file-invoice',
        href: 'factures/',
    },
    {
        title: 'Mes sociétés',
        icon: 'building-user',
        href: 'societes/',
    },
];

export default menuEntries;
